import { ArticleProducts as ArticleProductsComponent } from './ArticleProducts.component';
import { connector } from './ArticleProducts.connector';

export const ArticleProducts = connector(ArticleProductsComponent);
